import FpuiStep from './Step.vue'
import FpuiSteps from './Steps.vue'

export { FpuiSteps, FpuiStep }
export default { FpuiSteps, FpuiStep }
